"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationItemDtoNotificationTypeEnum = void 0;
exports.NotificationItemDtoNotificationTypeEnum = {
    Competition: 'competition',
    Submission: 'submission',
    User: 'user',
    Admin: 'admin',
    System: 'system',
    Custom: 'custom',
    ReferralReward: 'referral_reward',
    General: 'general'
};
